import * as FluencyIcons from './icons/index'
import { fluencyIcon } from './icons/index'

export const allFluencyIconsNames = Object.values(FluencyIcons).map(i => i.name)
export const allFluencyIconsData = Object.values(FluencyIcons).map(i => i.data)

export const isExistsTuqqiIcon = (name: string) => allFluencyIconsNames.includes(name as fluencyIcon)
export const getDefaultTuqqiIconName = () => 'public' as fluencyIcon
export const getDefaultTuqqiIcon = () => FluencyIcons.fluencyIconPublic.data
export { FluencyIcons }